import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class BandeiraValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let bandeira = model;
        
        if (!bandeira.idprobandeiraerp) {
            refs.idErpInput.focusedOut = true;
            validated = false;
        }

        if (!bandeira.descricao) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }
        if(!bandeira.prorede.idprorede){
            refs.redeInput.focusedOut = true;
            validated = false;
        }
        if (!validated){
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true));
        }
        return validated;
    }

}